export const postcodesEnergy = ['01561',
'01609',
'01616',
'01683',
'01723',
'01762',
'01774',
'01920',
'01936',
'01945',
'01968',
'01979',
'01983',
'01987',
'01990',
'01993',
'01994',
'01998',
'02694',
'02699',
'02943',
'02953',
'02957',
'02959',
'02979',
'02991',
'02994',
'02997',
'02999',
'03042',
'03044',
'03048',
'03051',
'03052',
'03053',
'03054',
'03055',
'03058',
'03096',
'03099',
'03103',
'03116',
'03119',
'03130',
'03149',
'03159',
'03172',
'03185',
'03197',
'03205',
'03226',
'03229',
'03238',
'03246',
'03249',
'03253',
'04129',
'04158',
'04159',
'04178',
'04179',
'04205',
'04207',
'04249',
'04288',
'04289',
'04299',
'04316',
'04319',
'04349',
'04356',
'04357',
'04416',
'04420',
'04425',
'04435',
'04442',
'04451',
'04463',
'04509',
'04519',
'04523',
'04539',
'04552',
'04564',
'04565',
'04567',
'04571',
'04575',
'04600',
'04603',
'04610',
'04613',
'04617',
'04618',
'04626',
'04639',
'04643',
'04651',
'04654',
'04668',
'04680',
'04683',
'04687',
'04703',
'04720',
'04736',
'04741',
'04746',
'04749',
'04758',
'04769',
'04774',
'04779',
'04808',
'04821',
'04824',
'04827',
'04828',
'04838',
'04849',
'04860',
'04861',
'04862',
'04874',
'04880',
'04886',
'04889',
'04895',
'04910',
'04916',
'04924',
'04928',
'04931',
'04932',
'04934',
'04936',
'04938',
'06116',
'06132',
'06179',
'06184',
'06188',
'06193',
'06198',
'06217',
'06231',
'06237',
'06242',
'06246',
'06249',
'06255',
'06258',
'06259',
'06268',
'06279',
'06295',
'06308',
'06311',
'06313',
'06317',
'06333',
'06343',
'06347',
'06366',
'06369',
'06385',
'06386',
'06388',
'06406',
'06408',
'06420',
'06425',
'06429',
'06449',
'06456',
'06458',
'06463',
'06464',
'06466',
'06467',
'06469',
'06484',
'06493',
'06502',
'06526',
'06528',
'06536',
'06537',
'06542',
'06543',
'06556',
'06567',
'06571',
'06577',
'06578',
'06618',
'06628',
'06632',
'06636',
'06638',
'06642',
'06647',
'06648',
'06667',
'06679',
'06682',
'06686',
'06688',
'06711',
'06712',
'06721',
'06722',
'06729',
'06749',
'06766',
'06772',
'06773',
'06774',
'06779',
'06780',
'06785',
'06792',
'06794',
'06796',
'06800',
'06803',
'06808',
'06809',
'06847',
'06886',
'06895',
'06901',
'06905',
'06917',
'06925',
'07318',
'07330',
'07333',
'07338',
'07343',
'07349',
'07356',
'07366',
'07368',
'07381',
'07387',
'07389',
'07407',
'07422',
'07426',
'07427',
'07429',
'07546',
'07552',
'07554',
'07557',
'07570',
'07580',
'07586',
'07589',
'07607',
'07613',
'07616',
'07619',
'07629',
'07639',
'07646',
'07747',
'07751',
'07768',
'07774',
'07778',
'07806',
'07819',
'07907',
'07919',
'07922',
'07924',
'07926',
'07927',
'07929',
'07937',
'07950',
'07952',
'07955',
'07957',
'07958',
'07973',
'07980',
'07985',
'07987',
'08056',
'08058',
'08064',
'08107',
'08112',
'08115',
'08118',
'08132',
'08134',
'08141',
'08144',
'08147',
'08209',
'08223',
'08228',
'08233',
'08236',
'08237',
'08239',
'08248',
'08258',
'08261',
'08262',
'08267',
'08294',
'08297',
'08301',
'08304',
'08309',
'08315',
'08321',
'08324',
'08328',
'08340',
'08344',
'08349',
'08352',
'08359',
'08371',
'08373',
'08393',
'08396',
'08412',
'08427',
'08428',
'08451',
'08459',
'08468',
'08485',
'08491',
'08496',
'08499',
'08527',
'08538',
'08539',
'08541',
'08543',
'08548',
'08606',
'08626',
'08645',
'08648',
'09123',
'09127',
'09128',
'09131',
'09212',
'09217',
'09221',
'09224',
'09228',
'09232',
'09235',
'09236',
'09241',
'09243',
'09244',
'09247',
'09249',
'09306',
'09322',
'09326',
'09328',
'09337',
'09350',
'09353',
'09355',
'09356',
'09366',
'09376',
'09380',
'09385',
'09387',
'09390',
'09392',
'09394',
'09399',
'09405',
'09419',
'09423',
'09427',
'09429',
'09430',
'09432',
'09434',
'09437',
'09439',
'09456',
'09465',
'09468',
'09471',
'09474',
'09481',
'09484',
'09487',
'09496',
'09509',
'09514',
'09518',
'09526',
'09544',
'09548',
'09557',
'09569',
'09573',
'09575',
'09577',
'09579',
'09599',
'09600',
'09603',
'09618',
'09619',
'09623',
'09627',
'09629',
'09633',
'09634',
'09638',
'09648',
'09661',
'09669',
'10115',
'10117',
'10119',
'10178',
'10179',
'10243',
'10245',
'10247',
'10249',
'10315',
'10317',
'10318',
'10319',
'10365',
'10367',
'10369',
'10405',
'10407',
'10409',
'10435',
'10437',
'10439',
'10551',
'10553',
'10555',
'10557',
'10559',
'10585',
'10587',
'10589',
'10623',
'10625',
'10627',
'10629',
'10707',
'10709',
'10711',
'10713',
'10715',
'10717',
'10719',
'10777',
'10779',
'10781',
'10783',
'10785',
'10787',
'10789',
'10823',
'10825',
'10827',
'10829',
'10961',
'10963',
'10965',
'10967',
'10969',
'10997',
'10999',
'12043',
'12045',
'12047',
'12049',
'12051',
'12053',
'12055',
'12057',
'12059',
'12099',
'12101',
'12103',
'12105',
'12107',
'12109',
'12157',
'12159',
'12161',
'12163',
'12165',
'12167',
'12169',
'12203',
'12205',
'12207',
'12209',
'12247',
'12249',
'12277',
'12279',
'12305',
'12307',
'12309',
'12347',
'12349',
'12351',
'12353',
'12355',
'12357',
'12359',
'12435',
'12437',
'12439',
'12459',
'12487',
'12489',
'12524',
'12526',
'12527',
'12529',
'12555',
'12557',
'12559',
'12587',
'12589',
'12619',
'12621',
'12623',
'12627',
'12629',
'12679',
'12681',
'12683',
'12685',
'12687',
'12689',
'13051',
'13053',
'13055',
'13057',
'13059',
'13086',
'13088',
'13089',
'13125',
'13127',
'13129',
'13156',
'13158',
'13159',
'13187',
'13189',
'13347',
'13349',
'13351',
'13353',
'13355',
'13357',
'13359',
'13403',
'13405',
'13407',
'13409',
'13435',
'13437',
'13439',
'13465',
'13467',
'13469',
'13503',
'13505',
'13507',
'13509',
'13581',
'13583',
'13585',
'13587',
'13589',
'13591',
'13593',
'13595',
'13597',
'13599',
'13627',
'13629',
'14050',
'14052',
'14053',
'14055',
'14057',
'14059',
'14089',
'14109',
'14129',
'14163',
'14165',
'14167',
'14169',
'14193',
'14195',
'14197',
'14199',
'14467',
'14469',
'14471',
'14473',
'14476',
'14478',
'14480',
'14482',
'14513',
'14532',
'14542',
'14547',
'14548',
'14550',
'14552',
'14554',
'14558',
'14612',
'14621',
'14624',
'14641',
'14656',
'14662',
'14669',
'14712',
'14715',
'14727',
'14728',
'14774',
'14776',
'14778',
'14789',
'14793',
'14797',
'14798',
'14806',
'14822',
'14823',
'14827',
'14828',
'14913',
'14929',
'14943',
'14947',
'14959',
'14974',
'14979',
'15236',
'15295',
'15299',
'15306',
'15320',
'15324',
'15326',
'15328',
'15345',
'15366',
'15370',
'15374',
'15377',
'15378',
'15517',
'15518',
'15526',
'15528',
'15537',
'15562',
'15566',
'15569',
'15711',
'15712',
'15713',
'15732',
'15738',
'15741',
'15745',
'15746',
'15748',
'15749',
'15754',
'15755',
'15757',
'15806',
'15827',
'15831',
'15834',
'15837',
'15838',
'15848',
'15859',
'15864',
'15868',
'15890',
'15898',
'15907',
'15910',
'15913',
'15936',
'15938',
'16225',
'16227',
'16230',
'16244',
'16247',
'16248',
'16259',
'16269',
'16278',
'16303',
'16306',
'16307',
'16321',
'16341',
'16348',
'16356',
'16359',
'16515',
'16540',
'16547',
'16548',
'16552',
'16556',
'16559',
'16562',
'16567',
'16727',
'16761',
'16766',
'16767',
'16775',
'16792',
'16798',
'16816',
'16818',
'16827',
'16831',
'16833',
'16835',
'16837',
'16845',
'16866',
'16868',
'16909',
'16928',
'16945',
'16949',
'17039',
'17087',
'17089',
'17091',
'17094',
'17098',
'17099',
'17109',
'17111',
'17121',
'17126',
'17129',
'17139',
'17153',
'17154',
'17159',
'17166',
'17168',
'17179',
'17192',
'17194',
'17207',
'17209',
'17213',
'17214',
'17217',
'17219',
'17235',
'17237',
'17248',
'17252',
'17255',
'17258',
'17268',
'17279',
'17291',
'17309',
'17321',
'17322',
'17326',
'17328',
'17329',
'17335',
'17337',
'17348',
'17349',
'17358',
'17367',
'17373',
'17375',
'17379',
'17389',
'17390',
'17391',
'17392',
'17398',
'17406',
'17419',
'17424',
'17429',
'17438',
'17440',
'17449',
'17454',
'17459',
'17495',
'17498',
'17506',
'17509',
'18059',
'18069',
'18107',
'18181',
'18182',
'18184',
'18190',
'18195',
'18196',
'18198',
'18209',
'18211',
'18225',
'18230',
'18233',
'18236',
'18239',
'18299',
'18311',
'18314',
'18317',
'18320',
'18334',
'18337',
'18347',
'18356',
'18374',
'18375',
'18437',
'18442',
'18445',
'18461',
'18465',
'18469',
'18507',
'18510',
'18513',
'18516',
'18519',
'18528',
'18546',
'18551',
'18556',
'18565',
'18569',
'18573',
'18574',
'18581',
'18586',
'18609',
'19339',
'19348',
'23923',
'23936',
'23942',
'23946',
'23948',
'23966',
'23968',
'23970',
'23972',
'23974',
'23992',
'23996',
'23999',
'36404',
'36414',
'36433',
'36448',
'36456',
'36466',
'36469',
'37308',
'37318',
'37327',
'37339',
'37345',
'37351',
'37355',
'37359',
'39307',
'39439',
'39444',
'53111',
'53113',
'53115',
'53117',
'53119',
'53121',
'53123',
'53125',
'53127',
'53129',
'53173',
'53175',
'53177',
'53179',
'53225',
'53227',
'53229',
'53639',
'53757',
'96515',
'96523',
'96524',
'96528',
'98527',
'98528',
'98529',
'98530',
'98544',
'98553',
'98554',
'98559',
'98574',
'98587',
'98590',
'98593',
'98596',
'98597',
'98617',
'98630',
'98631',
'98634',
'98639',
'98646',
'98660',
'98666',
'98667',
'98669',
'98673',
'98693',
'98694',
'98701',
'98716',
'98724',
'98743',
'98744',
'98746',
'99095',
'99100',
'99102',
'99189',
'99192',
'99195',
'99198',
'99310',
'99326',
'99330',
'99334',
'99338',
'99427',
'99428',
'99438',
'99439',
'99441',
'99444',
'99448',
'99510',
'99518',
'99610',
'99625',
'99628',
'99631',
'99634',
'99636',
'99638',
'99707',
'99713',
'99718',
'99734',
'99735',
'99752',
'99755',
'99759',
'99765',
'99768',
'99817',
'99819',
'99820',
'99826',
'99830',
'99831',
'99834',
'99837',
'99842',
'99846',
'99848',
'99867',
'99869',
'99880',
'99885',
'99887',
'99891',
'99894',
'99897',
'99947',
'99955',
'99958',
'99974',
'99976',
'99986',
'99988',
'99991',
'99994',
'99996',
'99998',
];

  export const postcodesGas = ["10115", "10117", "10119", "10178", "10179", "10243", "10245", "10247", "10249", "10315", "10317", "10318", "10319", "10365", "10367", "10369", "10405", "10407", "10409", "10435", "10437", "10439", "10551", "10553", "10555", "10557", "10559", "10585", "10587", "10589", "10623", "10625", "10627", "10629", "10707", "10709", "10711", "10713", "10715", "10717", "10719", "10777", "10779", "10781", "10783", "10785", "10787", "10789", "10823", "10825", "10827", "10829", "10961", "10963", "10965", "10967", "10969", "10997", "10999", "11011", "12043", "12045", "12047", "12049", "12051", "12053", "12055", "12057", "12059", "12099", "12101", "12103", "12105", "12107", "12109", "12157", "12159", "12161", "12163", "12165", "12167", "12169", "12203", "12205", "12207", "12209", "12247", "12249", "12277", "12279", "12305", "12307", "12309", "12347", "12349", "12351", "12353", "12355", "12357", "12359", "12435", "12437", "12439", "12459", "12487", "12489", "12524", "12526", "12527", "12529", "12555", "12557", "12559", "12587", "12589", "12619", "12621", "12623", "12625", "12627", "12629", "12679", "12681", "12683", "12685", "12687", "12689", "13051", "13053", "13055", "13057", "13059", "13086", "13088", "13089", "13125", "13127", "13129", "13156", "13158", "13159", "13187", "13189", "13347", "13349", "13351", "13353", "13355", "13357", "13359", "13403", "13405", "13407", "13409", "13435", "13437", "13439", "13465", "13467", "13469", "13503", "13505", "13507", "13509", "13581", "13583", "13585", "13587", "13589", "13591", "13593", "13595", "13597", "13599", "13627", "13629", "14050", "14052", "14053", "14055", "14057", "14059", "14089", "14109", "14129", "14163", "14165", "14167", "14169", "14193", "14195", "14197", "14199"];


// WEBPACK FOOTER //
// ./src/Assets/PostCodes.js